import { applyStyleMap } from "../shared-block-styles";

import { CSSProperties } from "react";

/**
 * A rule's appearance, for the canvas and for the inbox alike.
 *
 * `border: none; border-top: …` is how email draws one — the visible line is
 * the top border, not the element's own.
 */
export function getDividerStyles(
  attrs: Record<string, unknown>,
): CSSProperties {
  const styles: CSSProperties = {
    border: "none",
    borderTop: `${(attrs.thickness as string) || "1px"} solid ${
      (attrs.color as string) || "#e5e7eb"
    }`,
    margin: "0",
    width: "100%",
  };
  applyStyleMap(styles, attrs);
  return styles;
}
